import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import "./ParentQuestionerForm.css";
import { useSearchParams } from "react-router-dom";
import { get, post } from "../../services/api";

function ParentQuestionerForm() {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      id: 0,
      studentName: "",
      email: "",
      hearAboutUs: "",
      chooseNunAcademy: "",
      helpYourChildAnswer: "",
      emotionalConcernsAnswer: "",
      personalStrengths: "",
      areaschildNeedToDevelop: "",
      socialWillingness: "",
      anybodyKnownInNun: "",
      relationshipStatus: "",
      livesWith: "",
      bothParentsWork: "",
      typeOfWorkAns: "",
    },
  });
  const token = "123";
  const [searchParams] = useSearchParams();
  const [studentIdFromUrl, setstudentIdFromUrl] = useState(
    searchParams.get("id")
  );
  const centerId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");
  const [triggerRerender, setTriggerRerender] = useState(false);
  useEffect(() => {
    setstudentIdFromUrl(searchParams.get("id"));
    getQuestionerFormData();
  }, [triggerRerender]);
  const getQuestionerFormData = async () => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }
    try {
      const parentQuestioner = await get(
        `Registration/GetParentQuestionerById?id=${studentIdFromUrl}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (parentQuestioner != null) {
        const data = parentQuestioner.parentQuestioner;

        // Determine selected values
        const chosenAcademy = data.isAcademicReputation
          ? "isAcademicReputation"
          : data.isLocation
          ? "isLocation"
          : data.isSpecificPrograms
          ? "isSpecificPrograms"
          : data.isExtracurricularActivities
          ? "isExtracurricularActivities"
          : data.isWhyChooseNunOther
          ? "isWhyChooseNunOther"
          : null;

        const chosenHearAboutUs = data.isOnlineSearch
          ? "isOnlineSearch"
          : data.isSocialMedia
          ? "isSocialMedia"
          : data.isFriendAndFamily
          ? "isFriendAndFamily"
          : data.isAdvertisement
          ? "isAdvertisement"
          : data.isHearOther
          ? "isHearOther"
          : null;

        const chosenSocialWillingness = data.isVeryWilling
          ? "isVeryWilling"
          : data.isSomewhatWilling
          ? "isSomewhatWilling"
          : data.isNotWilling
          ? "isNotWilling"
          : null;

        const chosenRelationshipStatus = data.isMarried
          ? "isMarried"
          : data.isSeparated
          ? "isSeparated"
          : null;

        const chosenBothParentsWork = data.isBothParentYes
          ? "isBothParentYes"
          : data.isBothParentNo
          ? "isBothParentNo"
          : data.isBothParentOther
          ? "isBothParentOther"
          : null;
        const livesWith = data.isLiveMother
          ? "isLiveMother"
          : data.isLiveGrandparents
          ? "isLiveGrandparents"
          : data.isLiveFather
          ? "isLiveFather"
          : data.isLiveother
          ? "isLiveother"
          : null;
        reset({
          ...data,
          chooseNunAcademy: chosenAcademy,
          hearAboutUs: chosenHearAboutUs,
          socialWillingness: chosenSocialWillingness,
          relationshipStatus: chosenRelationshipStatus,
          bothParentsWork: chosenBothParentsWork,
          livesWith: livesWith,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const onSubmit = async (data) => {
    // Transform radio button values to booleans
    const transformedData = {
      id: data.id,
      studentName: data.studentName,
      email: data.email,
      isOnlineSearch: data.hearAboutUs === "isOnlineSearch",
      isSocialMedia: data.hearAboutUs === "isSocialMedia",
      isFriendAndFamily: data.hearAboutUs === "isFriendAndFamily",
      isAdvertisement: data.hearAboutUs === "isAdvertisement",
      isHearOther: data.hearAboutUs === "isHearOther",
      isAcademicReputation: data.chooseNunAcademy === "isAcademicReputation",
      isLocation: data.chooseNunAcademy === "isLocation",
      isSpecificPrograms: data.chooseNunAcademy === "isSpecificPrograms",
      isExtracurricularActivities:
        data.chooseNunAcademy === "isExtracurricularActivities",
      isWhyChooseNunOther: data.chooseNunAcademy === "isWhyChooseNunOther",
      helpYourChildAnswer: data.helpYourChildAnswer,
      emotionalConcernsAnswer: data.emotionalConcernsAnswer,
      personalStrengths: data.personalStrengths,
      areaschildNeedToDevelop: data.areaschildNeedToDevelop,
      isVeryWilling: data.socialWillingness === "isVeryWilling",
      isSomewhatWilling: data.socialWillingness === "isSomewhatWilling",
      isNotWilling: data.socialWillingness === "isNotWilling",
      anybodyKnownInNun: data.anybodyKnownInNun,
      isMarried: data.relationshipStatus === "isMarried",
      isSeparated: data.relationshipStatus === "isSeparated",
      isLiveMother: data.livesWith === "isLiveMother",
      isLiveFather: data.livesWith === "isLiveFather",
      isLiveGrandparents: data.livesWith === "isLiveGrandparents",
      isLiveother: data.livesWith === "isLiveother",
      isBothParentYes: data.bothParentsWork === "isBothParentYes",
      isBothParentNo: data.bothParentsWork === "isBothParentNo",
      isBothParentOther: data.bothParentsWork === "isBothParentOther",
      typeOfWorkAns: data.typeOfWorkAns,
      centerId: centerId,
    };

    console.log(transformedData);
    //return false; // Uncomment this for testing

    try {
      const response = await post(
        "Registration/AddParentQuestioner",
        transformedData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.isSuccess) {
        toast.success(response.message);
        reset();
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  return (
    <div className="form-container">
      <div className="form-paper">
        <h1 className="form-title">Parent Questionnaire</h1>
        <p className="form-description">
          Please take a few minutes to share your experience with us.
        </p>
        <div className="form-divider"></div>

        <form onSubmit={handleSubmit(onSubmit)}>
          {/* Question 1 - Name */}
          <div className="form-controls">
            <label className="question-label">
              1. Student Name? <span className="required">*</span>
            </label>
            <Controller
              name="studentName"
              control={control}
              rules={{ required: "This field is required" }}
              render={({ field }) => (
                <>
                  <input
                    {...field}
                    type="text"
                    className={`form-input ${
                      errors.studentName ? "error" : ""
                    }`}
                    placeholder="Your answer"
                  />
                  {errors.studentName && (
                    <span className="error-message">
                      {errors.studentName.message}
                    </span>
                  )}
                </>
              )}
            />
          </div>

          {/* Question 2 - Email */}
          <div className="form-controls">
            <label className="question-label">
              2. Email address <span className="required">*</span>
            </label>
            <Controller
              name="email"
              control={control}
              rules={{
                required: "Email is required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Invalid email address",
                },
              }}
              render={({ field }) => (
                <>
                  <input
                    {...field}
                    type="email"
                    className={`form-input ${errors.email ? "error" : ""}`}
                    placeholder="Your email"
                  />
                  {errors.email && (
                    <span className="error-message">
                      {errors.email.message}
                    </span>
                  )}
                </>
              )}
            />
          </div>

          {/* Question 3 - How did you hear about us */}
          <div className="form-controls">
            <label className="question-label">
              3. How did you first hear about Nün Academy?{" "}
              <span className="required">*</span>
            </label>
            <div className="checkbox-group">
              {[
                { name: "isOnlineSearch", label: "Online Search" },
                { name: "isSocialMedia", label: "Social Media" },
                {
                  name: "isFriendAndFamily",
                  label: "Friends/Family Recommendation",
                },
                { name: "isAdvertisement", label: "Advertisement" },
                { name: "isHearOther", label: "Other" },
              ].map((option) => (
                <Controller
                  key={option.name}
                  name="hearAboutUs"
                  control={control}
                  rules={{ required: "This field is required" }}
                  render={({ field }) => (
                    <label className="radio-option">
                      <input
                        type="radio"
                        value={option.name}
                        checked={field.value === option.name}
                        onChange={() => field.onChange(option.name)}
                      />
                      {option.label}
                    </label>
                  )}
                />
              ))}
              {errors.hearAboutUs && (
                <span className="error-message">This field is required</span>
              )}
            </div>
          </div>

          {/* Question 4 - Why choose Nun Academy */}
          <div className="form-controls">
            <label className="question-label">
              4. Why did you choose Nün Academy?
            </label>
            <div className="checkbox-group">
              {[
                { name: "isAcademicReputation", label: "Academic Reputation" },
                { name: "isLocation", label: "Location" },
                {
                  name: "isSpecificPrograms",
                  label: "Specific Programs Offered",
                },
                {
                  name: "isExtracurricularActivities",
                  label: "Extracurricular Activities",
                },
                { name: "isWhyChooseNunOther", label: "Other" },
              ].map((option) => (
                <Controller
                  key={option.name}
                  name="chooseNunAcademy"
                  control={control}
                  render={({ field }) => (
                    <label className="radio-option">
                      <input
                        type="radio"
                        value={option.name}
                        checked={field.value === option.name}
                        onChange={() => field.onChange(option.name)}
                      />
                      {option.label}
                    </label>
                  )}
                />
              ))}
            </div>
          </div>

          {/* Question 5 - Help child transition */}
          <div className="form-controls">
            <label className="question-label">
              5. Is there anything we can do as a school that will help your
              child transition into their new school?
            </label>
            <Controller
              name="helpYourChildAnswer"
              control={control}
              render={({ field }) => (
                <textarea
                  {...field}
                  className="form-textarea"
                  rows={4}
                  placeholder="Your answer..."
                />
              )}
            />
          </div>

          {/* Question 6 - Medical concerns */}
          <div className="form-controls">
            <label className="question-label">
              6. Is there any medical, social or emotional concerns that we
              should know about?
            </label>
            <Controller
              name="emotionalConcernsAnswer"
              control={control}
              render={({ field }) => (
                <textarea
                  {...field}
                  className="form-textarea"
                  rows={4}
                  placeholder="Your answer..."
                />
              )}
            />
          </div>

          {/* Question 7 - Personal strengths */}
          <div className="form-controls">
            <label className="question-label">
              7. What are your child's personal strengths?
            </label>
            <Controller
              name="personalStrengths"
              control={control}
              render={({ field }) => (
                <textarea
                  {...field}
                  className="form-textarea"
                  rows={4}
                  placeholder="Your answer..."
                />
              )}
            />
          </div>

          {/* Question 8 - Areas to develop */}
          <div className="form-controls">
            <label className="question-label">
              8. What are the areas you would like to see your child develop in?
            </label>
            <Controller
              name="areaschildNeedToDevelop"
              control={control}
              render={({ field }) => (
                <textarea
                  {...field}
                  className="form-textarea"
                  rows={4}
                  placeholder="Your answer..."
                />
              )}
            />
          </div>

          {/* Question 9 - Social interaction */}
          <div className="form-controls">
            <label className="question-label">
              9. Ability and willingness to socially interact with others
            </label>
            <div className="checkbox-group">
              {[
                { name: "isVeryWilling", label: "Very Willing" },
                { name: "isSomewhatWilling", label: "Somewhat Willing" },
                { name: "isNotWilling", label: "Not Willing" },
              ].map((option) => (
                <Controller
                  key={option.name}
                  name="socialWillingness"
                  control={control}
                  render={({ field }) => (
                    <label className="radio-option">
                      <input
                        type="radio"
                        value={option.name}
                        checked={field.value === option.name}
                        onChange={() => field.onChange(option.name)}
                      />
                      {option.label}
                    </label>
                  )}
                />
              ))}
            </div>
          </div>

          {/* Question 10 - Know anyone */}
          <div className="form-controls">
            <label className="question-label">
              10. Does your child know anybody in Nun Academy?
            </label>
            <Controller
              name="anybodyKnownInNun"
              control={control}
              render={({ field }) => (
                <textarea
                  {...field}
                  className="form-textarea"
                  rows={4}
                  placeholder="Your answer..."
                />
              )}
            />
          </div>

          {/* Question 11 - Relationship status */}
          <div className="form-controls">
            <label className="question-label">
              11. Could you share some details about your relationship status
            </label>
            <div className="checkbox-group">
              {[
                { name: "isMarried", label: "Married" },
                { name: "isSeparated", label: "Separated" },
              ].map((option) => (
                <Controller
                  key={option.name}
                  name="relationshipStatus"
                  control={control}
                  render={({ field }) => (
                    <label className="radio-option">
                      <input
                        type="radio"
                        value={option.name}
                        checked={field.value === option.name}
                        onChange={() => field.onChange(option.name)}
                      />
                      {option.label}
                    </label>
                  )}
                />
              ))}
            </div>
          </div>

          {/* Question 12 - If separated, lives with */}
          <div className="form-controls">
            <label className="question-label">
              12. If parents are separated, student lives with?
            </label>
            <div className="checkbox-group">
              {[
                { name: "isLiveMother", label: "Mother" },
                { name: "isLiveFather", label: "Father" },
                { name: "isLiveGrandparents", label: "Grandparents" },
                { name: "isLiveother", label: "Other" },
              ].map((option) => (
                <Controller
                  key={option.name}
                  name="livesWith"
                  control={control}
                  render={({ field }) => (
                    <label className="radio-option">
                      <input
                        type="radio"
                        value={option.name}
                        checked={field.value === option.name}
                        onChange={() => field.onChange(option.name)}
                      />
                      {option.label}
                    </label>
                  )}
                />
              ))}
            </div>
          </div>

          {/* Question 13 - Both parents work */}
          <div className="form-controls">
            <label className="question-label">13. Do both parents work?</label>
            <div className="checkbox-group">
              {[
                { name: "isBothParentYes", label: "Yes" },
                { name: "isBothParentNo", label: "No" },
                { name: "isBothParentOther", label: "Other" },
              ].map((option) => (
                <Controller
                  key={option.name}
                  name="bothParentsWork"
                  control={control}
                  render={({ field }) => (
                    <label className="radio-option">
                      <input
                        type="radio"
                        value={option.name}
                        checked={field.value === option.name}
                        onChange={() => field.onChange(option.name)}
                      />
                      {option.label}
                    </label>
                  )}
                />
              ))}
            </div>
          </div>

          {/* Question 14 - Type of work */}
          <div className="form-controls">
            <label className="question-label">
              14. If Yes, can you specify the type of work
            </label>
            <Controller
              name="typeOfWorkAns"
              control={control}
              render={({ field }) => (
                <textarea
                  {...field}
                  className="form-textarea"
                  rows={4}
                  placeholder="Your answer..."
                />
              )}
            />
          </div>

          <div className="form-divider"></div>
          <div className="form-actions">
            <button
              type="button"
              className="submit-button"
              onClick={() => reset()}
            >
              Clear
            </button>
            <div className="col-md-9"></div>
            <button type="submit" className="submit-button">
              Submit
            </button>
          </div>
        </form>
      </div>

      <p className="form-footer">
        This content is neither created nor endorsed by Google.
      </p>
    </div>
  );
}

export default ParentQuestionerForm;
